<template>
    <div  class="row">
        <div class="col-md-7">
            <confirm-delivery />
            <payment />
            <div class="complete">
                <button v-bind:disabled="inProgress || cartState!='payment_selected' || invalid" class="btn btn-primary" @click="complete">{{ completeMessage }}</button>
            </div>
        </div>

        <order-summary />

    </div>
</template>
<script>
    import OrderSummary from "./OrderSummary";
    import ConfirmDelivery from "./ConfirmDelivery";
    import Payment from "./Payment";
    export default {
        components: {Payment, ConfirmDelivery, OrderSummary},
        methods: {
            complete() {
                if (this.paymentMethod.code == 'PS-CC') {
                    this.$store.dispatch('prepareStripePayment')
                        .then(()=> {
                            if (this.$store.state.stripe.error.length==0) {
                                this.$store.dispatch('complete').then(()=>{
                                    console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!')
                                }).catch(()=>{
                                    return false
                                })
                            } else {
                                return false
                            }
                        })
                        .catch(()=>{
                            console.log('ooooooopps....')
                            return false
                        })
                } else {
                    this.$store.dispatch('complete')
                }
            }
        },
        computed: {
            inProgress() {
                return this.$store.state.inProgress
            },
            cartState () {
                return this.$store.state.cart.checkoutState
            },
            completeMessage () {
                if (this.$store.state.cart.checkoutState=='payment_selected') {
                    let label = 'Order and pay ' + this.$options.filters.formatMoney(this.$store.state.cart.totals.total)
                    if ( this.$store.state.cart.payments[0].method.code.indexOf('PS-')==0 ) {
                        return label + ' now'
                    } if ( this.$store.state.cart.payments[0].method.code.indexOf('PO-')==0 ) {
                        return label + ' on pickup'
                    } else {
                        return 'Something is wrong with your order'
                    }
                } else {
                    return 'Order is not complete'
                }
            },
            paymentMethod () {
                if (this.$store.state.cart.payments.length) {
                    return this.$store.state.cart.payments[0].method
                } else {
                    return null
                }
            },
            invalid () {
                return !this.$store.state.completeData.isComplete
            }
        },
        watch: {
            method (newValue) {
                if (newValue != this.cartMethod) {
                    this.$store.dispatch('updatePayment', [0, newValue])
                }
            }
        }

    }
</script>